import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

const FRONT_RIGHT_SIDE_PANEL_LABEL = 'Front Right Side Panel';

interface FrontRightSidePanelProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function FrontRightSidePanel(props: FrontRightSidePanelProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label={FRONT_RIGHT_SIDE_PANEL_LABEL}
      width={326}
      height={48}
      viewBox="0 0 326 48"
      position={{top: 0, left: 117}}
    >
      <path
        d="M318 33C298.183 26.4222 293 7.9756 293 1.00044H78L77.7211 1.00269C45.7211 1.00269 4 32.0001 4 32.0001L227 27.0001C237 27 260.6 30 275 46C280.003 44.6714 294.162 44.0311 308 46C309.264 43.1668 314.244 36.9781 325 35C322 34 319.702 33.565 318 33Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M318 33C298.183 26.4222 293 7.9756 293 1.00044H78L77.7211 1.00269C45.7211 1.00269 4 32.0001 4 32.0001L227 27.0001C237 27 260.6 30 275 46C280 45 294 44 308 46C309.264 43.1668 314.244 36.9781 325 35C322 34 319.702 33.565 318 33Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M301 20.5217C264.677 20.2801 236.893 20 217 20C117.543 20 49.2225 23.459 17 27.8261C11 28.8696 9 29.913 4 32"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
